import React, { Component } from 'react'
import { toast } from 'react-toastify'
import { connect } from 'react-redux'
import _ from 'lodash'
import Cookies from 'js-cookie'
import FileSaver from 'file-saver'
import ReactHTMLParser from 'react-html-parser'
import Moment from 'moment'

import { Get } from 'utils/axios'
import getDomainURL from 'utils/api'

const HOC = WrappedComponent => {
  class WithHOC extends Component {
    state = {
      loading: false,
      panelCollections: [],
      searchParams: {
        company_id: 0,
        branch_id: 0,
        start_date: new Date(),
        end_date: new Date()
      }
    }

    load = param => this.setState({ loading: param })
    requestSuccess = success => toast.success( success )
    requestError = error => toast.error( ({ closeToast }) => ReactHTMLParser( error.message ) )

    onChangePanelCollectionsHOC = ( key, val ) => this.setState({ [ key ]: val })

    getPanelCollections = ( company_id, branch_id, start_date, end_date ) => Get(
      `/collections/panels_collection?company_id=${ company_id }&branch_id=${ branch_id }&start_date=${ start_date }&end_date=${ end_date }`,
      this.getPanelCollectionsSuccess,
      this.getPanelCollectionsError,
      this.load
    )
    getPanelCollectionsSuccess = payload => this.setState({ panelCollections: payload })
    getPanelCollectionsError = error => this.requestError( error )

    downloadPanelCollectionsPDF = ( company_id, branch_id, start_date, end_date ) => {
      let headers = new Headers()
      headers.append( 'Authorization', `Bearer ${ Cookies.get( 'PRIMEVIEW_WEB_TOKEN' ) }` )
      this.load( true )
      fetch(
        `${ getDomainURL() }/collections/download_panels_collection?company_id=${ company_id }&branch_id=${ branch_id }&start_date=${ start_date }&end_date=${ end_date }`,
        {
          headers: headers
        }
      ).then( res => res.blob()).then( blobby => {
        this.load( false )
        return FileSaver.saveAs( blobby, `${ Moment().format( 'YYYYMMDDHH:mm' ) }_panel_collections.pdf` )
      }).catch( error => {
        this.load( false )
        this.requestError( 'Failed to save panel collections. Please try again.' )
      })
    }

    render = () => {
      return(
        <WrappedComponent
          { ...this.props }
          onLoadPanelCollectionsHOC = { this.state.loading }
          panelCollections = { this.state.panelCollections }
          searchParams={ this.state.searchParams }
          onChangePanelCollectionsHOC={ this.onChangePanelCollectionsHOC }
          getPanelCollections={ this.getPanelCollections }
          downloadPanelCollectionsPDF={ this.downloadPanelCollectionsPDF } />
      )
    }
  }

  const mapStateToProps = state => ({ data: state })
  return connect( mapStateToProps )( WithHOC )
}

export default HOC